export * from '../../components/Quote/Quote';
